import useSelector from '@app/hooks/useSelector';

import type { ProjectType } from '../../../../types/project';
import {
    getPlaceholderFormatSelect,
    getPlaceholderFormatWhitelist,
    getPluralFormatSelect,
    getPluralFormatWhitelist,
} from '../../reducers/downloadData/selectors';
import type { FileFormat } from '../../types';
import Options from './Options';
import type { Value } from './types';
import preparePlaceholderFormatInputOptions from './utils/preparePlaceholderFormatInputOptions';
import preparePluralFormatOptions from './utils/preparePluralFormatOptions';

interface OptionsContainerProps {
    value: Value;
    fileFormat: FileFormat;
    projectType: ProjectType;
    isNoLanguageFoldersSwitchDisabled: boolean;
    projectId: string;
    onChange: (value: Value) => void;
}

const OptionsContainer = ({
    value,
    fileFormat,
    projectType,
    isNoLanguageFoldersSwitchDisabled,
    projectId,
    onChange,
}: OptionsContainerProps) => {
    const pluralFormatSelect = useSelector(getPluralFormatSelect);
    const pluralFormatWhitelist = useSelector(getPluralFormatWhitelist);
    const placeholderFormatSelect = useSelector(getPlaceholderFormatSelect);
    const placeholderFormatWhitelist = useSelector(getPlaceholderFormatWhitelist);

    const pluralFormatOptions = preparePluralFormatOptions(fileFormat, pluralFormatSelect, pluralFormatWhitelist);
    const placeholderFormatOptions = preparePlaceholderFormatInputOptions(
        fileFormat,
        placeholderFormatSelect,
        placeholderFormatWhitelist,
    );

    return (
        <section aria-label="Advance settings for export">
            <Options
                value={value}
                fileFormat={fileFormat}
                projectType={projectType}
                isNoLanguageFoldersSwitchDisabled={isNoLanguageFoldersSwitchDisabled}
                pluralFormatOptions={pluralFormatOptions}
                placeholderFormatOptions={placeholderFormatOptions}
                projectId={projectId}
                onChange={onChange}
            />
        </section>
    );
};

export default OptionsContainer;
